import React from "react";
import frontI from '../../images/home/frontend.png';

function FrontendDevelopment() {
    return (
        <>

            <Hero />

            <section className="service-content-section">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <img
                                src={frontI}
                                alt="Frontend Development"
                                className="service-main-image"
                            />
                        </div>

                        <div className="col-lg-6">
                            <div className="service-content">

                                <h2>Modern Interfaces For Better Digital Experiences</h2>

                                <p>
                                    We create responsive and user-friendly interfaces that make
                                    applications easy to use across desktop, tablet, and mobile
                                    devices.
                                </p>

                                <p>
                                    Our frontend experience includes React, Angular, Salesforce,
                                    and other modern technologies based on project requirements.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-features-section">
                <div className="container">
                    <div className="section-heading text-center">
                        <h2>Technologies We Work With</h2>
                    </div>

                    <div className="row g-4">
                        {[
                            ["React", "Build modern component-based interfaces and web applications."],
                            ["Angular", "Develop structured and scalable enterprise applications."],
                            ["Salesforce", "Create and customize user experiences within Salesforce solutions."]
                        ].map(([title, text]) => (
                            <div className="col-lg-4 col-md-6" key={title}>
                                <div className="service-feature-card">
                                    <h3>{title}</h3>
                                    <p>{text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <CTA />
        </>
    );
}

function Hero() {
    return (
        <section
            className="service-page-hero"
            style={{ backgroundColor: '#002952' }}
        >
            <div className="container">
                <div className="service-hero-content">

                    <h1>Frontend Development</h1>
                    <p style={{ color: '#FF7D37' }}>
                        Responsive and modern interfaces built with today's leading
                        frontend technologies.
                    </p>
                </div>
            </div>
        </section>
    );
}

function CTA() {
    return (
        <section className="service-cta-section">
            <div className="container">
                <div className="service-cta-box">
                    <div>
                        <span>FRONTEND DEVELOPMENT</span>
                        <h2>Need A Modern User Interface?</h2>
                        <p>Let's build a better experience for your users.</p>
                    </div>
                    <a href="/contactus" className="service-cta-button">
                        Contact Us
                    </a>
                </div>
            </div>
        </section>
    );
}

export default FrontendDevelopment;